

import React, { Component } from 'react';
import { LoadingOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import stopPropagation from 'src/utils/stop-propagation';
import SideDrawer from './drawer/side-drawer';

const ICON = '$icon';

const iframeStyle = {
  display: 'block',
  width: '100%',
  height: '380px',
  border: '0',
};

const DRAWER_HEADER_HEIGHT = 64;
const DRAWER_BODY_PADDING = 6;
const DRAWER_HEADER_BORDER_WIDTH = 1;
const LOADING_ICON_SIZE = 14;

const clsPrefix = 'app-help-modal-link';

@inject(({ ui }) => ({ ui }))
@observer
class HelpModalLink extends Component {
  static propTypes = {
    href: PropTypes.string.isRequired,
    showInDrawer: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
    ui: PropTypes.object,
  };

  static defaultProps = {
    showInDrawer: true,
  };

  state = {
    visible: false,
    loading: true,
  };

  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.handleToggle();
  };

  handleToggle = () => {
    this.setState(({ visible }) => ({
      visible: !visible,
    }));
  };

  handleClose = (e) => {
    e?.preventDefault();
    this.setState({
      visible: false,
    });
  };

  handleIframeLoad = () => {
    this.setState({ loading: false });
  };

  parseHelpHref(href) {
    return href.slice(5);
  }

  getModalUrl() {
    const { protocol, host } = window.location;
    const { href } = this.props;
    return `${protocol}//${host}/help/article-box?article=${encodeURIComponent(
      this.parseHelpHref(href)
    )}`;
  }

  render() {
    const {
      href: unusedHref,
      showInDrawer,
      children,
      ui,
      ...linkProps
    } = this.props;
    const { visible, loading } = this.state;

    const modalUrl = this.getModalUrl();
    const topBarHeight = parseInt(ui?.totalTopBarHeight ?? '60px', 10);
    const headerOffset =
      DRAWER_HEADER_HEIGHT +
      DRAWER_BODY_PADDING * 2 +
      (ui?.isMobileSize ? DRAWER_HEADER_BORDER_WIDTH * 2 : topBarHeight) +
      (loading ? LOADING_ICON_SIZE : 0);

    const iframe = (
      <>
        {loading && (
          <div className={`${clsPrefix}__iframe-loading`}>
            <LoadingOutlined />
          </div>
        )}
        <iframe
          title={modalUrl}
          src={modalUrl}
          style={{
            ...iframeStyle,
            ...(showInDrawer
              ? {
                  height: `calc(100vh - ${headerOffset}px)`,
                  opacity: loading ? 0.8 : 1,
                }
              : null),
          }}
          onLoad={this.handleIframeLoad}
        />
      </>
    );

    return (
      <span className={clsPrefix} onClick={stopPropagation} role="button">
        <a href={modalUrl} onClick={this.handleClick} {...linkProps}>
          {children && children[0] === ICON ? (
            <QuestionCircleOutlined />
          ) : (
            children
          )}
        </a>
        {showInDrawer ? (
          <SideDrawer
            className={`${clsPrefix}__drawer`}
            title="Help"
            visible={visible}
            onClose={this.handleClose}
          >
            {iframe}
          </SideDrawer>
        ) : (
          <Modal
            title={null}
            visible={visible}
            onCancel={this.handleClose}
            wrapClassName={`${clsPrefix}__modal vertical-center-modal`}
            footer={null}
          >
            {iframe}
          </Modal>
        )}
      </span>
    );
  }
}

export default HelpModalLink;
